import { useEffect } from 'react';

/**
 * Custom hook for keyboard shortcuts
 * @param {Object} callbacks - Object with callback functions
 * @param {Function} callbacks.onSave - Save callback (Ctrl/Cmd + S)
 * @param {Function} callbacks.onUndo - Undo callback (Ctrl/Cmd + Z)
 * @param {Function} callbacks.onRedo - Redo callback (Ctrl/Cmd + Shift + Z)
 * @param {Function} callbacks.onCancel - Cancel callback (Escape)
 * @param {boolean} enabled - Whether shortcuts are enabled
 */
export const useKeyboardShortcuts = (callbacks, enabled = true) => {
  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (e) => {
      // Ctrl/Cmd + S to save
      if ((e.ctrlKey || e.metaKey) && e.key === 's') {
        e.preventDefault();
        if (callbacks.onSave) {
          callbacks.onSave();
        }
      }

      // Ctrl/Cmd + Z to undo (without Shift)
      if ((e.ctrlKey || e.metaKey) && e.key === 'z' && !e.shiftKey) {
        e.preventDefault();
        if (callbacks.onUndo) {
          callbacks.onUndo();
        }
      }

      // Ctrl/Cmd + Shift + Z to redo
      if ((e.ctrlKey || e.metaKey) && e.key === 'z' && e.shiftKey) {
        e.preventDefault();
        if (callbacks.onRedo) {
          callbacks.onRedo();
        }
      }

      // Escape to cancel/close
      if (e.key === 'Escape') {
        if (callbacks.onCancel) {
          callbacks.onCancel();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [callbacks, enabled]);
};

